import 'alpinejs'

function repositionMenu(menu, trigger) {
    menu.style.transform = 'none';
    const menuRect = menu.getBoundingClientRect();
    const triggerRect = trigger.getBoundingClientRect();
    const parentRect = menu.offsetParent.getBoundingClientRect();
    let idealLeft = triggerRect.left + (triggerRect.width / 2) - (menuRect.width / 2);
    if(idealLeft < 0) idealLeft = 0;
    if(idealLeft + menuRect.width > window.innerWidth) idealLeft = window.innerWidth - menuRect.width;
    let intendedLeft = idealLeft - parentRect.left;
    menu.style.left = intendedLeft + 'px';
}



    window.menuHoverComponent =function menuHoverComponent() {
        return {
            hover: false,
            hoverMenu: false,
            flyoutMenuOpen:false,

            setButton() { 
                this.hover = true
                this.flyoutMenuOpen=true
                this.repositionFlyout();
            },
            unsetButton() { 
                this.hover = false
                this.close()
            },
            setHover() { 
                this.hoverMenu = true
                this.flyoutMenuOpen=true
                this.repositionFlyout()
             },
            unsetHover() { 
                
                this.hoverMenu = false
                this.close()
            
            },
          
            close() { 
                setTimeout(()=>{
                    if(!this.hover && !this.hoverMenu){
                            this.flyoutMenuOpen=false
                    }
                },50)
            },

            repositionFlyout() {
                this.$nextTick(() => {
                    // Use a more specific selector for the flyout menu if needed
                    const menu = this.$el.querySelector('.flyout-menu');
                    // Use the <a> element as the trigger for calculation
                    const trigger = this.$el.querySelector('a');
                    if (menu && trigger) {
                        // Check if the menu's dimensions are available; if not, wait a bit longer
                        if (menu.getBoundingClientRect().width === 0) {
                            setTimeout(() => repositionMenu(menu, trigger), 5);
                        } else {
                            repositionMenu(menu, trigger);
                        }
                    }
                });
            }
      
        }
    }


    